import styles from './Title.module.scss';

export default function Title({ children, fontSize = 24 }) {
  return (
    <h1 className={styles.title} style={{ fontSize: fontSize }}>
      {children}
    </h1>
  );
}
